import { Box, Button, Space, Text } from '@mantine/core';
import { openModal } from '@mantine/modals';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack'; // dist/entry.webpack';
import { useState } from 'react';
import { Trans } from '@lingui/react';
import { IconDownload } from '@tabler/icons';
import { useElementSize } from '@mantine/hooks';
import { FileS } from '../../Service/FileS';

// eslint-disable-next-line import/prefer-default-export
export const openFileViewModal = (props) =>
  openModal({
    size: 'xl',
    title: (
      <Text weight="bolder" size="xl">
        {props.fileName}
      </Text>
    ),
    children: <FileViewModal {...props} />,
  });

const FileViewModal = ({ fileName, contentType, file }) => {
  if (contentType.includes('pdf')) {
    return <PdfView file={file} fileName={fileName} />;
  }

  if (contentType.includes('image')) {
    return (
      <>
        <Box sx={{ textAlign: 'center' }}>
          <img
            src={URL.createObjectURL(file)}
            alt={fileName}
            style={{ display: 'block', maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain', margin: '0 auto' }}
          />
        </Box>
        <Space h="xl" />
        <Box sx={{ textAlign: 'center' }}>
          <Button leftIcon={<IconDownload size={20} />} onClick={() => FileS.download(fileName, file)}>
            Herunterladen
          </Button>
        </Box>
      </>
    );
  }

  return <Text>Nicht unterstütztes Dateiformat.</Text>;
};

const PdfView = ({ fileName, file }) => {
  const [, setPageNumber] = useState(1);
  const [numPages, setNumPages] = useState(0);
  const { ref, width } = useElementSize();
  const pageWidth = width > 0 ? Math.min(width, 1000) : 1;

  function onDocumentLoadSuccess(numPages) {
    setNumPages(numPages._pdfInfo.numPages);
  }

  function updateCurrentPage(element) {
    setPageNumber(element + 1);
  }

  return (
    <>
      <Box
        ref={ref}
        sx={{
          maxWidth: '100%',
          overflowX: 'hidden',
          '& .react-pdf__Page': {
            maxWidth: '100%',
            margin: '0 auto 16px',
          },
          '& .react-pdf__Page canvas': {
            maxWidth: '100%',
            height: 'auto !important',
          },
        }}
      >
        <Document
          file={file}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={(e) => {
            console.error(e);
          }}
          error={<Trans id="document.generate.error" />}
        >
          {Array.from(Array(numPages).keys()).map((el) => (
            <div key={el} onMouseOver={() => updateCurrentPage(el)} onFocus={() => updateCurrentPage(el)}>
              <Page pageNumber={el + 1} width={pageWidth} />
            </div>
          ))}
        </Document>
      </Box>
      <Space h="xl" />
      <Box sx={{ textAlign: 'center' }}>
        <Button leftIcon={<IconDownload size={20} />} onClick={() => FileS.download(fileName, file)}>
          Herunterladen
        </Button>
      </Box>
    </>
  );
};
